import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
import { action } from '@ember/object';
import { replace } from '@square/dashboard-utilities/utils/window';
import { generateSavingsAccountUrl } from '@banking/ui/utils/savings-account-url';

export default class ErrorController extends Controller {
  @service currentApplicationFlow;

  @readOnly('currentApplicationFlow.bankcBalanceId')
  bankcBalanceId;

  @action
  goToGeneralSavings() {
    const url = generateSavingsAccountUrl(this.bankcBalanceId);
    replace(url);
  }
}
